<template>
	<div class="seller-settle">
		<div class="btnbox">
			<el-button size="small" @click="goList">云仓列表</el-button>
			<el-button size="small" @click="goStock">在仓库存</el-button>
			<el-button size="small" @click="goRecord">入仓记录</el-button>
		</div>
		<div class="money-grid">
			<div class="money-item">
				<div class="label">已结算（到手）</div>
				<div class="value">¥{{ fenToYuan(balance.settled_total) }}</div>
			</div>
			<div class="money-item muted">
				<div class="label">已提现占用</div>
				<div class="value">¥{{ fenToYuan(balance.withdrawn_total) }}</div>
			</div>
			<div class="money-item">
				<div class="label">可提现</div>
				<div class="value">¥{{ fenToYuan(balance.available_amount) }}</div>
			</div>
			<div class="money-actions">
				<el-button type="primary" size="small" :disabled="!canApply" @click="openApply">申请提现</el-button>
				<div class="sub" v-if="!canApply">可提现满 100 元后可申请</div>
			</div>
		</div>
		<p class="tip">到手 = 供货价全额。平台费由买家承担，本页不展示。提现占用含待审核/已通过/已打款，拒绝后自动释放。</p>
		<el-tabs v-model="activeTab" @tab-click="onTabClick">
			<el-tab-pane label="销售" name="sale"></el-tab-pane>
			<el-tab-pane label="提现记录" name="withdraw"></el-tab-pane>
		</el-tabs>
		<div class="filterdiv filterty" v-if="activeTab === 'sale'">
			<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0">
				<el-form-item>
					<el-select v-model="formfilter.warehouse_id" placeholder="全部云仓" filterable clearable>
						<el-option label="全部云仓" value=""></el-option>
						<el-option :label="v.name" :value="v.id" v-for="v in warehouses" :key="v.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="formfilter.style_number" placeholder="款号" clearable
						@keyup.enter.native="onfilter"></el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="formfilter.daterange" type="daterange" start-placeholder="开始日期"
						end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onfilter">查询</el-button>
					<el-button @click="onreset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div v-if="activeTab === 'sale'">
		<div class="section-title">按款汇总</div>
		<el-table :data="statsList" border size="mini" style="width: 100%">
			<el-table-column prop="style_number" label="款号" align="center" header-align="center" min-width="120px"></el-table-column>
			<el-table-column prop="quantity" label="件数" align="center" header-align="center" width="80px"></el-table-column>
			<el-table-column label="到手合计" align="center" header-align="center" min-width="110px">
				<template slot-scope="scope">¥{{ fenToYuan(scope.row.cost_amount) }}</template>
			</el-table-column>
		</el-table>
		<div class="pagediv" v-if="statsTotal > 0">
			<el-pagination background layout="prev, pager, next, total" :current-page="statsPage"
				:page-size="statsPageSize" :total="statsTotal" @current-change="handleStatsPage"></el-pagination>
		</div>

		<div class="section-title">销售明细</div>
		<el-table :data="saleList" border size="mini" style="width: 100%">
			<el-table-column prop="id" label="明细ID" align="center" header-align="center" width="80px"></el-table-column>
			<el-table-column label="云仓" align="center" header-align="center" min-width="110px">
				<template slot-scope="scope">{{ warehouseName(scope.row.warehouse_id) }}</template>
			</el-table-column>
			<el-table-column prop="style_number" label="款号" align="center" header-align="center" min-width="110px"></el-table-column>
			<el-table-column prop="size" label="尺码" align="center" header-align="center" width="70px"></el-table-column>
			<el-table-column prop="quantity" label="件数" align="center" header-align="center" width="70px"></el-table-column>
			<el-table-column label="供货价" align="center" header-align="center" width="90px">
				<template slot-scope="scope">¥{{ fenToYuan(scope.row.cost_price) }}</template>
			</el-table-column>
			<el-table-column label="到手" align="center" header-align="center" width="90px">
				<template slot-scope="scope">¥{{ fenToYuan(lineCost(scope.row)) }}</template>
			</el-table-column>
			<el-table-column prop="sale_time_str" label="销售时间" align="center" header-align="center" width="160px"></el-table-column>
		</el-table>
		<div class="pagediv" v-if="saleTotal > 0">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="salePage" :page-size="salePageSize" :total="saleTotal"
				@current-change="handleSalePage" @size-change="handleSaleSize"></el-pagination>
		</div>
		</div>

		<div v-if="activeTab === 'withdraw'">
			<div class="filterdiv filterty">
				<el-form :inline="true" :model="withdrawFilter" class="demo-form-inline" size="small">
					<el-form-item>
						<el-select v-model="withdrawFilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in withdrawStates" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onWithdrawFilter">查询</el-button>
						<el-button @click="onWithdrawReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="withdrawList" border size="mini" style="width: 100%">
				<el-table-column prop="id" label="单号" align="center" width="70px"></el-table-column>
				<el-table-column label="金额" align="center" width="110px">
					<template slot-scope="scope">¥{{ fenToYuan(scope.row.amount) }}</template>
				</el-table-column>
				<el-table-column label="收款方式" align="center" width="90px">
					<template slot-scope="scope">{{ accountTypeName(scope.row.account_type) }}</template>
				</el-table-column>
				<el-table-column prop="state_str" label="状态" align="center" width="90px">
					<template slot-scope="scope">
						<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
					</template>
				</el-table-column>
				<el-table-column label="备注 / 打款" align="center" min-width="180px">
					<template slot-scope="scope">
						<div v-if="scope.row.state == 3">{{ scope.row.audit_remark || '-' }}</div>
						<div v-else-if="scope.row.state == 4">打款 {{ scope.row.pay_time_str || '-' }}</div>
						<div v-else>{{ scope.row.audit_remark || '-' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="create_time_str" label="申请时间" align="center" width="160px"></el-table-column>
			</el-table>
			<div class="pagediv" v-if="withdrawTotal > 0">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="withdrawPage" :page-size="withdrawPageSize" :total="withdrawTotal"
					@current-change="handleWithdrawPage" @size-change="handleWithdrawSize"></el-pagination>
			</div>
		</div>

		<el-dialog title="申请提现" :visible.sync="applyShow" width="480px" :before-close="closeApply">
			<div class="forms" v-if="applyShow">
				<el-form label-width="110px">
					<el-form-item label="可提现">
						<div>¥{{ fenToYuan(balance.available_amount) }}（最低 100 元）</div>
					</el-form-item>
					<el-form-item label="提现金额">
						<el-input v-model="applyForm.amount_yuan" placeholder="请输入金额">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="收款方式">
						<el-radio-group v-model="applyForm.account_type">
							<el-radio :label="1">支付宝</el-radio>
							<el-radio :label="2">微信</el-radio>
							<el-radio :label="3">银行卡</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="收款账号">
						<el-input v-model="applyForm.account_no" maxlength="128" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="收款人">
						<el-input v-model="applyForm.account_name" maxlength="64" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeApply">取消</el-button>
				<el-button type="primary" :loading="applying" @click="onApply">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseSettle',
		data() {
			return {
				balance: {
					settled_total: 0,
					withdrawn_total: 0,
					available_amount: 0
				},
				warehouses: [],
				formfilter: {
					warehouse_id: '',
					style_number: '',
					daterange: []
				},
				statsList: [],
				statsPage: 1,
				statsPageSize: 20,
				statsTotal: 0,
				saleList: [],
				salePage: 1,
				salePageSize: 20,
				saleTotal: 0,
				activeTab: 'sale',
				withdrawList: [],
				withdrawPage: 1,
				withdrawPageSize: 20,
				withdrawTotal: 0,
				withdrawFilter: {
					state: ''
				},
				withdrawStates: [
					{ id: 1, name: '待审核' },
					{ id: 2, name: '通过' },
					{ id: 3, name: '不通过' },
					{ id: 4, name: '已打款' }
				],
				applyShow: false,
				applying: false,
				applyForm: {
					amount_yuan: '',
					account_type: 1,
					account_no: '',
					account_name: ''
				}
			}
		},
		computed: {
			canApply() {
				return Number(this.balance.available_amount || 0) >= 10000
			}
		},
		mounted() {
			if (this.$route.query.tab === 'withdraw') {
				this.activeTab = 'withdraw'
			}
			this.loadWarehouses()
			this.loadBalance()
			this.loadStats()
			this.loadSales()
			if (this.activeTab === 'withdraw') {
				this.loadWithdraws()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			warehouseName(id) {
				var row = this.warehouses.find(function (item) {
					return Number(item.id) === Number(id)
				})
				return row ? row.name : (id || '--')
			},
			lineCost(row) {
				return Number(row.cost_price || 0) * Number(row.quantity || 0)
			},
			goList() {
				this.$router.push('/seller/warehouse/index')
			},
			goRecord() {
				this.$router.push('/seller/warehouse/record')
			},
			goStock() {
				this.$router.push('/seller/warehouse/stock')
			},
			accountTypeName(type) {
				return { 1: '支付宝', 2: '微信', 3: '银行卡' }[Number(type)] || '-'
			},
			onTabClick() {
				if (this.activeTab === 'withdraw') {
					this.loadWithdraws()
				}
			},
			onWithdrawFilter() {
				this.withdrawPage = 1
				this.loadWithdraws()
			},
			onWithdrawReset() {
				this.withdrawFilter.state = ''
				this.onWithdrawFilter()
			},
			handleWithdrawPage() {
				this.loadWithdraws()
			},
			handleWithdrawSize(val) {
				this.withdrawPage = 1
				this.withdrawPageSize = val
				this.loadWithdraws()
			},
			loadWithdraws() {
				var params = {
					page: this.withdrawPage,
					limit: this.withdrawPageSize
				}
				if (this.withdrawFilter.state !== '' && this.withdrawFilter.state !== null) {
					params.state = this.withdrawFilter.state
				}
				this.$axios.get('api/cloud_warehouse/withdraw_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.withdrawList = data.list || []
						this.withdrawTotal = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			openApply() {
				if (!this.canApply) {
					this.$message.warning('可提现余额不足 100 元')
					return
				}
				this.applyForm = {
					amount_yuan: '',
					account_type: 1,
					account_no: '',
					account_name: ''
				}
				this.applyShow = true
			},
			closeApply() {
				this.applyShow = false
			},
			onApply() {
				var amount = yuanToFen(this.applyForm.amount_yuan)
				if (isNaN(amount) || amount < 10000) {
					this.$message.warning('提现金额不能低于100.00元')
					return
				}
				if (!String(this.applyForm.account_no || '').trim()) {
					this.$message.warning('请输入收款账号')
					return
				}
				if (!String(this.applyForm.account_name || '').trim()) {
					this.$message.warning('请输入收款人姓名')
					return
				}
				this.applying = true
				this.$axios.post('api/cloud_warehouse/withdraw_apply', {
					amount: amount,
					account_type: this.applyForm.account_type,
					account_no: this.applyForm.account_no,
					account_name: this.applyForm.account_name
				}).then(res => {
					this.applying = false
					if (res.data.code === 0) {
						this.$message.success('提现申请已提交')
						this.closeApply()
						this.activeTab = 'withdraw'
						this.loadBalance()
						this.loadWithdraws()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.applying = false
					console.log(err)
				})
			},
			filterParams() {
				var params = {}
				if (this.formfilter.warehouse_id !== '' && this.formfilter.warehouse_id !== null) {
					params.warehouse_id = this.formfilter.warehouse_id
				}
				if (this.formfilter.style_number) {
					params.style_number = this.formfilter.style_number
				}
				var range = this.formfilter.daterange
				if (range && range.length === 2) {
					params.btime = Math.floor(new Date(range[0] + ' 00:00:00').getTime() / 1000)
					params.etime = Math.floor(new Date(range[1] + ' 23:59:59').getTime() / 1000)
				}
				return params
			},
			onfilter() {
				this.statsPage = 1
				this.salePage = 1
				this.loadBalance()
				this.loadStats()
				this.loadSales()
			},
			onreset() {
				this.formfilter = {
					warehouse_id: '',
					style_number: '',
					daterange: []
				}
				this.onfilter()
			},
			handleStatsPage(page) {
				this.statsPage = page
				this.loadStats()
			},
			handleSalePage() {
				this.loadSales()
			},
			handleSaleSize(val) {
				this.salePage = 1
				this.salePageSize = val
				this.loadSales()
			},
			loadWarehouses() {
				this.$axios.get('api/cloud_warehouse/warehouse_list', {
					params: { page: 1, limit: 100 }
				}).then(res => {
					if (res.data.code === 0) {
						this.warehouses = (res.data.data && res.data.data.list) || []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			loadBalance() {
				this.$axios.get('api/cloud_warehouse/balance').then(res => {
					if (res.data.code === 0) {
						this.balance = res.data.data || this.balance
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			loadStats() {
				var params = this.filterParams()
				params.page = this.statsPage
				params.limit = this.statsPageSize
				this.$axios.get('api/cloud_warehouse/sale_stats', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.statsList = data.list || []
						this.statsTotal = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			loadSales() {
				var params = this.filterParams()
				params.page = this.salePage
				params.limit = this.salePageSize
				params.role = 'seller'
				this.$axios.get('api/cloud_warehouse/sale_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.saleList = data.list || []
						this.saleTotal = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-settle {
		padding-bottom: 20px;
	}

	.money-grid {
		display: flex;
		margin-bottom: 8px;
	}

	.money-item {
		flex: 1;
		margin-right: 12px;
		padding: 16px;
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		background: #fff;
		.label {
			color: #909399;
			font-size: 13px;
			margin-bottom: 8px;
		}
		.value {
			font-size: 22px;
			font-weight: 600;
			color: #F65730;
		}
		&:last-child {
			margin-right: 0;
		}
	}

	.money-item.muted .value {
		color: #C0C4CC;
	}

	.money-actions {
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-width: 140px;
		.sub {
			color: #909399;
			font-size: 12px;
			margin-top: 6px;
		}
	}

	.state-1 {
		color: #E6A23C;
	}
	.state-2 {
		color: #409EFF;
	}
	.state-3 {
		color: #909399;
	}
	.state-4 {
		color: #67C23A;
	}

	.tip {
		font-size: 12px;
		color: #909399;
		margin-bottom: 12px;
	}

	.section-title {
		font-weight: 600;
		margin: 16px 0 8px;
	}

	.pagediv {
		margin: 8px 0 4px;
		text-align: right;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/settle.vue